import Cooldown from '@map/components/PhoneVerificationForm/Cooldown';
import { makeStyles } from '@map/theme';
import { Typography } from '@mui/material';
import useLocationState from '@shared/hooks/useLocationState';
import Button from '@ui/Button';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PublicPage from '../shared/PublicPage';

const useStyles = makeStyles(() => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

type Props = {
  onSubmit: (values: { username: string }) => Promise<string | undefined>;
};

const ForgotPasswordViaEmail = ({ onSubmit }: Props) => {
  const { classes } = useStyles();
  const [username] = useLocationState('username', '');
  const [cooldown, setCooldown] = useState(0);
  const resend = useCallback(
    () => onSubmit({ username }).then(() => setCooldown((v) => v + 1)),
    [onSubmit, username],
  );

  return (
    <PublicPage
      title={<FormattedMessage id="forgot_password.title" />}
      innerClassName={classes.content}
    >
      <Typography variant="body2" align="center" sx={{ marginBottom: 6 }}>
        <FormattedMessage id="password_reset.email_sent" tagName="p" />
        <FormattedMessage id="password_reset.email_instructions" tagName="p" />
      </Typography>

      <Cooldown running={cooldown} messageIntlKey="forgot_password.email_cooldown">
        <Typography variant="body3" align="center">
          <FormattedMessage id="password_reset.resend_email_prompt" />
        </Typography>
        <Button variant="tertiary" onClick={resend}>
          <FormattedMessage id="password_reset.resend_button" />
        </Button>
      </Cooldown>
    </PublicPage>
  );
};

export default ForgotPasswordViaEmail;
